/* eslint-disable no-nested-ternary */
import React, { useEffect, useMemo } from 'react';
import { useQuery } from 'react-query';
import useDeliveriesValues from '../../../../../model/useDeliveriesValues';
import useAddresses from '../../../../../model/useAddresses';
import NewAddress from './NewAddress';
import UserAddresses from './UserAddresses';
import SpaceAddresses from './SpaceAddresses';
import {
  DeliveryService, AddressService, SpaceService,
} from '../../../../../support/services/api';

import './styles.css';

export default function Address(props) {
  const {
    commands, sharedStates,
  } = props;

  const { consumerSpaceData, userId, spaceId, space } = sharedStates;

  const { sharedStates: deliveryStates, commands: deliveryCommands, metaStates: deliveryMetaStates } = useDeliveriesValues(spaceId);
  const { commands: addressesCommands, metaStates:addressesMetaStates } = useAddresses(
    consumerSpaceData ? consumerSpaceData.producerId : userId,
    consumerSpaceData ? 'producer' : 'user',
  );

  const {
    data: spaceAddresses,
  } = useQuery(
    ['addresses', spaceId],
    () => SpaceService().getAddresses(spaceId),
    { enabled: !!spaceId },
  );

  const {
    data: consumerAddresses, isLoading: consumerAddressesLoading,
  } = useQuery(
    ['addresses', consumerSpaceData, userId],
    () => AddressService().getAddresses(
      consumerSpaceData
        ? 'producer'
        : 'user',
      consumerSpaceData
        ? consumerSpaceData.producerId
        : userId,
    ),
  );

  useEffect(() => {
    if (!(consumerAddressesLoading)) {
      if (sharedStates.order.deliveryMethod === 'home_delivery') commands.process.updateDataController('newAddress', !consumerAddresses?.length);
    }
  }, [consumerAddresses, sharedStates.order.deliveryMethod, consumerAddressesLoading]);

  const {
    data: deliveryValues,isLoading:deliveryValuesLoading, isFetching:deliveryValuesFetching, isIdle: deliveryValuesIdle
  } = useQuery(
    ['deliveries', spaceId, consumerAddresses],
    () => DeliveryService().getDistancesAndValues(spaceId, consumerAddresses),
    {
      enabled: !!consumerAddresses?.length && Object.keys(space.delivery).includes('homeDelivery'),
    },
  );

  const addressesWithDeliveryValues = useMemo(() => consumerAddresses?.map((address) => ({ ...address, ...deliveryValues?.find((delivery) => delivery.name === `${address.street}, ${address.number} - ${address.neighborhood}, ${address.city} - ${address.uf}, ${address.zipCode}`) })), [consumerAddresses, deliveryValues]);
  
  return consumerAddressesLoading ? <></>
    : (sharedStates?.process?.controllers?.newAddress
      ? (
        <NewAddress
          commands={{ ...commands, delivery: deliveryCommands, addresses: addressesCommands }}
          sharedStates={{ ...sharedStates, delivery: deliveryStates }}
          metaStates={{ delivery: deliveryMetaStates, address:addressesMetaStates }}
        />
      )
      : sharedStates.order.deliveryMethod === 'home_delivery'
        ? (
          <UserAddresses
            commands={{ ...commands, ...addressesCommands }}
            sharedStates={sharedStates}
            remoteStates={{ addresses: addressesWithDeliveryValues }}
            metaStates={{deliveryValuesLoading, deliveryValuesFetching, deliveryValuesIdle}}
          />
        )
        : (
          <SpaceAddresses
            commands={commands}
            sharedStates={sharedStates}
            remoteStates={{ addresses: spaceAddresses }}
          />
        )
    );
}
